import React from 'react';

import { ReactComponent as WishlistIcon } from './wishlist.svg';

const CardSkeleton = props => {
	const { selected } = props;
	return (
		<div className='item-list-wrapper'>
			<div className='item-list'>
				<div className='item-image'>
					<div className={`wishlist-icon ${!selected ? 'white-bg' : ''}`}>
						<WishlistIcon />
					</div>
				</div>
				<div className='item-details'>
					<div className='item-name'></div>
					<div className='item-name item-para'></div>
				</div>
			</div>
		</div>
	);
};
const Phone = () => {
	return (
		<>
			<div className='col-xxl-5'>
				<div className='col-phone'>
					<div className='notch'></div>
					<div className='phone-wrapper'>
						<div className='phone-header'></div>
						<div className='phone-body-wrapper'>
							<CardSkeleton selected={true} />
							<CardSkeleton />
							<CardSkeleton />
							<CardSkeleton />
						</div>
					</div>
					<div className='safe-area'></div>
				</div>
			</div>
		</>
	);
};

export default Phone;
